import styled, { css } from 'styled-components';

import {
  getStatusColor,
  getStatusTextColor,
} from 'newComponents/NewNotifications/NotificationItem/util';

type StatusProps = {
  statusCode: string;
  newOrigin?: boolean;
};

export const Container = styled.div<StatusProps>`
  background-color: ${({ statusCode }) => getStatusColor(statusCode, 'refuel')};
  color: ${({ statusCode }) => getStatusTextColor(statusCode, 'refuel')};
  border-radius: 8px;
  padding: 5px 7px;
  font-weight: 600;
  font-size: 14px;
  font-family: 'Mangueira', sans-serif;

  ${({ newOrigin }) =>
    newOrigin &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
      width: fit-content;
    `}
`;
